<template>
	<form class="login-form" @submit.prevent="submit">
		<FieldInput name="identifier" type="email" label="Email" v-model="$v.email.$model" />
		<FieldInput name="password" type="password" label="Password" v-model="$v.password.$model" />
		<SubmitButton wide :invalid="invalid" label="Log in" />
	</form>
</template>

<script>
import { mapActions } from 'vuex'
import FieldInput from '@/components/FieldInput'
import SubmitButton from '@/components/SubmitButton'
import { vLogin } from '@/lib/validators'

export default {
	name: 'LoginForm',
	data() {
		return {
			email: '',
			password: '',
		}
	},
	validations: {
		...vLogin,
	},
	computed: {
		invalid() {
			return this.$v.$invalid
		},
	},
	methods: {
		...mapActions({
			logIn: 'auth/logIn',
			toast: 'toast/push',
		}),
		async submit() {
			// Do nothing if invalid
			if (this.invalid) return

			const payload = {
				email: this.email,
				password: this.password,
			}

			if (await this.logIn(payload)) {
				// Redirect to dashboard
				this.$router.push({ name: 'Dashboard' })
			} else {
				// Show errror message
				this.toast({
					message: 'Login failed, please check your details.',
					severity: 'error',
				})
			}
		},
	},
	components: {
		FieldInput,
		SubmitButton,
	},
}
</script>

<style lang="scss" scoped>
@import '~scss/layout';

.login-form {
	width: 100%;
	max-width: 20rem;

	@include not-last {
		margin-bottom: 2rem;
	}
}
</style>
